// --- Action Types (should match saga) ---
const PROCESS_PRODUCT_STEP = "PROCESS_PRODUCT_STEP"; // Although handled by saga, good to list
const PRODUCT_STEP_PENDING = "PRODUCT_STEP_PENDING";
const PRODUCT_STEP_SUCCESS = "PRODUCT_STEP_SUCCESS";
const PRODUCT_STEP_FAILURE = "PRODUCT_STEP_FAILURE";
const RESET_PRODUCT_STEP_STATE = "RESET_PRODUCT_STEP_STATE"; // Optional reset action
const RESET_PRODUCT_UUID = "RESET_PRODUCT_UUID";

const initialState = {
    loading: false,
    error: null, // Stores the error message string
    success: false, // Flag indicating the last step attempt succeeded
    currentTransitionKey: null, // Identifier for the step being processed
    lastProductUuid: null, // Stores the UUID after successful creation/update
    // lastProductUuid: "88cde0da-3cb6-48ca-9b95-095892d9273e",
    results: [], // Stores the results array from the last SUCCESS/FAILURE action for potential debugging
};

const productWorkflowReducer = (state = initialState, action) => {
    switch (action.type) {
        case PRODUCT_STEP_PENDING:
            return {
                ...state,
                loading: true,
                error: null,
                success: false,
                currentTransitionKey: action.payload.transitionKey,
                results: [], // Clear previous results
            };

        case PRODUCT_STEP_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                success: true,
                // Keep currentTransitionKey from PENDING until next step or reset
                lastProductUuid: action.payload.newProductUuid || state.lastProductUuid, // Update UUID if provided
                results: action.payload.results || [],
            };

        case PRODUCT_STEP_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error || "An unknown error occurred.", // Store the error message
                success: false,
                // Keep currentTransitionKey from PENDING until next step or reset
                results: action.payload.results || [], // Store results even on failure
            };

        case RESET_PRODUCT_STEP_STATE:
            // Resets flags, but keeps lastProductUuid potentially
            return {
                ...state, // Keep lastProductUuid
                loading: false,
                error: null,
                success: false,
                currentTransitionKey: null,
                results: [],
            };
        case RESET_PRODUCT_UUID:
            // Resets flags, but keeps lastProductUuid potentially
            return {
                lastProductUuid: '', // Keep lastProductUuid
                loading: false,
                error: null,
                success: false,
                currentTransitionKey: null,
                results: [],
            };

        default:
            return state;
    }
};

export default productWorkflowReducer;